import React, { useState } from 'react';
import './Pricing.css';

const PLANS = [
  {
    id: 'Free',
    name: 'Free',
    description: 'Explore the tools, no credit card needed.',
    monthlyPrice: 0,
    yearlyPrice: 0,
    features: ['No credit card required', 'Limited tasks', 'Standard features'],
  },
  {
    id: 'Starter',
    name: 'Starter',
    description: 'For indie developers and side projects.',
    monthlyPrice: 19,
    yearlyPrice: 17,
    features: ['Everything in Free', '280 Premium LLM Calls/day', '7-Day Free Trial'],
  },
  {
    id: 'Advanced',
    name: 'Advanced',
    description: 'For professional developers shipping daily.',
    monthlyPrice: 49,
    yearlyPrice: 44,
    features: ['Everything in Starter', '750 Premium LLM Calls/day', 'Multi-Repository Indexing', 'Analytics Dashboard'],
  },
  {
    id: 'Enterprise',
    name: 'Enterprise',
    description: 'For organizations with advanced security and support needs.',
    monthlyPrice: 99,
    yearlyPrice: 89,
    features: ['Everything in Advanced', 'SSO & Audit Logs', 'Dedicated support', 'Custom SLAs'],
  },
];

function Pricing() {
  const [billingCycle, setBillingCycle] = useState('Yearly');

  return (
    <div className="Pricing-page">
      <header className="Pricing-header">
        <h1>Pricing</h1>
        <p className="Pricing-subtitle">More power, when you need it.</p>
        <div className="Pricing-toggle">
          <button
            type="button"
            className={`Pricing-toggle-btn ${billingCycle === 'Monthly' ? 'active' : ''}`}
            onClick={() => setBillingCycle('Monthly')}
          >
            Monthly
          </button>
          <button
            type="button"
            className={`Pricing-toggle-btn ${billingCycle === 'Yearly' ? 'active' : ''}`}
            onClick={() => setBillingCycle('Yearly')}
          >
            Yearly
          </button>
        </div>
      </header>

      <section className="Pricing-plans">
        <h2 className="Pricing-section-title">Essential Plans</h2>
        <div className="Pricing-cards">
          {PLANS.map((plan) => {
            const price = billingCycle === 'Yearly' ? plan.yearlyPrice : plan.monthlyPrice;
            const isFree = plan.id === 'Free';
            return (
              <div key={plan.id} className="Pricing-card">
                <h3 className="Pricing-card-name">{plan.name}</h3>
                <p className="Pricing-card-desc">{plan.description}</p>
                <div className="Pricing-card-price">
                  {isFree ? (
                    '$0/month'
                  ) : (
                    <>
                      ${price}/user/month
                      {billingCycle === 'Yearly' && <span className="Pricing-billed">, billed annually</span>}
                    </>
                  )}
                </div>
                <ul className="Pricing-card-features">
                  {plan.features.map((f, i) => (
                    <li key={i}>
                      <span className="Pricing-check">✓</span> {f}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}

export default Pricing;
